import React from 'react';
import './DattaSirAwardBlog.css';

import Image1 from '../../assets/png/sir-gilbert-award/01.png'
import Image2 from '../../assets/png/sir-gilbert-award/02.png'
import Image3 from '../../assets/png/sir-gilbert-award/03.png'
import Image4 from '../../assets/png/sir-gilbert-award/04.png'
import Image5 from '../../assets/png/sir-gilbert-award/05.jpeg'
import Image6 from '../../assets/png/sir-gilbert-award/06.jpeg'
import Image7 from '../../assets/png/sir-gilbert-award/07.jpeg'
import Image8 from '../../assets/png/sir-gilbert-award/08.jpeg'

const DattaSirAwardBlog = () => {
  return (
    <div className="blog-container">
      <header className="blog-header">
        <h1 className="blog-title">Dr. R. K. Datta Awarded the Prestigious Sir Gilbert Walker Gold Medal</h1>
        <p className="blog-subtitle">Indian Meteorological Society Honors Lifetime Contributions to Meteorology</p>
        <div className="blog-meta">
          <span className="blog-date">November 18, 2025</span>
          <span className="blog-location">IITM, Pune, India</span>
        </div>
      </header>

      <div className="blog-content">
        <section className="intro-section">
          <div className="intro-image">
            <img 
              src={Image8} 
              alt="Dr. R. K. Datta holding his Sir Gilbert Walker Gold Medal" 
            />
            <p className="image-caption">Dr. R. K. Datta with the prestigious Sir Gilbert Walker Gold Medal</p>
          </div>
          
          <div className="intro-text">
            <p>
              On 18th November 2025, at the inaugural function of the IMS International Symposium INTROMET-2025 
              held at the Indian Institute of Tropical Meteorology (IITM), Pune, Dr. Rattan Kumar Datta was 
              jointly conferred the Sir Gilbert Walker Gold Medal. This biennial 
              award, instituted by the Indian Meteorological Society (IMS), recognizes outstanding and pioneering 
              contributions in the field of meteorology and related areas.
            </p>
          </div>
        </section>

        <section className="ceremony-section">
          <h2>The Award Ceremony</h2>
          
          <div className="image-grid">
            <div className="grid-item">
              <img 
                src={Image1} 
                alt="Dr. Datta addressing the audience" 
              />
              <p>Dr. Datta addressing the gathering</p>
            </div>
            
            <div className="grid-item">
              <img 
                src={Image2} 
                alt="Receiving the award on stage" 
              />
              <p>Receiving the prestigious award</p>
            </div>
            
            <div className="grid-item">
              <img 
                src={Image3} 
                alt="Award presentation moment" 
              />
              <p>Honored by the Indian Meteorological Society</p>
            </div>
            
            <div className="grid-item">
              <img 
                src={Image4} 
                alt="Dr. Datta in the audience" 
              />
              <p>At the INTROMET-2025 symposium</p>
            </div>
          </div>
          
          <div className="ceremony-details">
            <p>
              The award was presented during the inaugural function of INTROMET-2025, a three-day international 
              symposium (18th-20th November 2025) that brought together meteorologists and climate scientists 
              from around the world. Dr. Datta's acceptance of this honor in person added a special significance 
              to the event, inspiring the next generation of atmospheric scientists present at the symposium.
            </p>
          </div>
        </section>

        <section className="medal-section">
          <h2>The Sir Gilbert Walker Gold Medal</h2>
          
          <div className="medal-images">
            <div className="medal-item">
              <img 
                src={Image6} 
                alt="Front side of the gold medal" 
              />
              <p>Front side of the medal</p>
            </div>
            
            <div className="medal-item">
              <img 
                src={Image7} 
                alt="Back side of the gold medal" 
              />
              <p>Back side of the medal</p>
            </div>
          </div>
          
          <p>
            The Sir Gilbert Walker Gold Medal is one of the highest honors in Indian meteorology, 
            established to honor lifetime contributions towards discovery of new phenomena, understanding 
            of atmospheric processes, and developing meteorological services for societal benefits. 
            Previous awardees include some of the most distinguished names in Indian atmospheric sciences.
          </p>
        </section>

        <section className="biography-section">
          <h2>A Trailblazing Career in Meteorology</h2>
          
          <div className="stage-image">
            <img 
              src={Image5} 
              alt="Dr. Datta on stage receiving award" 
            />
            <p>Dr. Datta being honored on stage at IITM, Pune</p>
          </div>
          
          <div className="bio-content">
            <p>
              After earning his M.Sc. (Hons.) in Physics from Punjab University, Dr. Datta began his career 
              as a lecturer before joining the Oil and Natural Gas Commission (ONGC) as a Geophysicist, and 
              subsequently the India Meteorological Department (IMD) in 1961. His quest for scientific 
              excellence led him to advance training at Pune, where he stood first in his batch.
            </p>
            
            <p>
              In 1969, he was posted to Delhi as the founder and head of the Numerical Weather Prediction 
              (NWP) Group, where he trained generations of scientists in NWP techniques and computer programming. 
              Under his visionary leadership, IMD acquired its first IBM 360/44 computer, ushering in the era 
              of operational numerical weather forecasting in India. His pioneering research earned him a 
              Gold Medal for the best scientific paper of the year.
            </p>
            
            <p>
              Dr. Datta obtained his Ph.D. from the Indian Institute of Technology, Delhi, for his thesis 
              titled "Certain Dynamical Aspects of Monsoon Circulation and Its Prediction". Part of this 
              seminal work was published by the Vatican Academy, where he was invited to deliver a special lecture.
            </p>
            
            <p>
              During his fellowship at the European Centre for Medium Range Weather Forecasts (ECMWF) in 
              Reading, UK, he critically analyzed and improved the accuracy of tropical forecasts, earning 
              recognition from the global scientific community.
            </p>
            
            <h3>Transformative Contribution: Establishing NCMRWF</h3>
            
            <p>
              His most transformative contribution came with the conception and establishment of the National 
              Centre for Medium Range Weather Forecasting (NCMRWF). Despite institutional challenges, his 
              unwavering determination led to the installation of India's first CRAY X-MP supercomputer, 
              dedicated to the nation by the Hon'ble Prime Minister on 25 March 1989. This historic achievement 
              placed India among the world leaders in numerical weather prediction and advanced computing.
            </p>
            
            <p>
              Dr. Datta's foresight extended to planning the future of Indian meteorology through collaboration 
              with international centers, acquisition of land for NCMRWF at Noida, and mentorship of a new 
              generation of atmospheric scientists. His vision laid the foundation for the modern era of 
              high-performance computing and scientific weather forecasting in India.
            </p>
          </div>
        </section>

        <section className="conclusion-section">
          <h2>A Legacy of Excellence</h2>
          
          <div className="quote-box">
            <blockquote>
              "In recognition of his lifelong dedication, scientific excellence, and trailblazing leadership 
              that transformed India's meteorological capability, the Indian Meteorological Society is 
              privileged to confer upon Dr. Rattan Kumar Datta the prestigious Sir Gilbert Walker Gold Medal."
              <footer>— Indian Meteorological Society Citation</footer>
            </blockquote>
          </div>
          
          <p>
            Dr. R. K. Datta's journey from a young physicist to the architect of India's numerical weather 
            prediction capabilities is a testament to visionary leadership, scientific rigor, and unwavering 
            commitment to national progress. The Sir Gilbert Walker Gold Medal serves not just as recognition 
            of past achievements, but as an inspiration for future generations of scientists to push the 
            boundaries of meteorological science.
          </p>
          
          <p>
            Today, as Director of the Mohyal Educational & Research Institute of Technology (MERIT), 
            New Delhi, Dr. Datta continues to mentor young minds, ensuring that his legacy of excellence 
            in scientific research and nation-building continues to flourish.
          </p>
        </section>

        <footer className="blog-footer">
          <div className="footer-content">
            <h3>About the Sir Gilbert Walker Gold Medal</h3>
            <p>
              The Sir Gilbert Walker Gold Medal is awarded biennially by the Indian Meteorological Society 
              to honor lifetime contributions to meteorology. More details about the award and previous 
              awardees can be found at: 
              <a href="https://imetsociety.org/gilbert-walker-gold-medal/" target="_blank" rel="noopener noreferrer">
                https://imetsociety.org/gilbert-walker-gold-medal/
              </a>
            </p>
            
            <div className="footer-note">
              <p>
                <strong>Event:</strong> INTROMET-2025 International Symposium<br />
                <strong>Date:</strong> 18th-20th November 2025<br />
                <strong>Venue:</strong> Indian Institute of Tropical Meteorology (IITM), Pune, India<br />
                <strong>Organizer:</strong> Indian Meteorological Society
              </p>
            </div>
          </div>
        </footer>
      </div>
    </div>
  );
};

export default DattaSirAwardBlog;
